import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { Subject } from '../observable/subject';
var _subject = /*#__PURE__*/_classPrivateFieldLooseKey("subject");
export class ObservableSet extends Set {
  constructor(...args) {
    super(...args);
    Object.defineProperty(this, _subject, {
      writable: true,
      value: new Subject()
    });
    this.add = value => {
      super.add(value);
      _classPrivateFieldLooseBase(this, _subject)[_subject].next(this);
      return this;
    };
    this.delete = value => {
      const result = super.delete(value);
      _classPrivateFieldLooseBase(this, _subject)[_subject].next(this);
      return result;
    };
    this.clear = () => {
      super.clear();
      _classPrivateFieldLooseBase(this, _subject)[_subject].next(this);
    };
    this.subscribe = observer => {
      const subscription = _classPrivateFieldLooseBase(this, _subject)[_subject].subscribe(observer);
      return () => subscription.unsubscribe();
    };
  }
}